import { render, staticRenderFns } from "./DisasterPreventionManagement.vue?vue&type=template&id=0aabe9e5&scoped=true&"
import script from "./DisasterPreventionManagement.vue?vue&type=script&lang=js&"
export * from "./DisasterPreventionManagement.vue?vue&type=script&lang=js&"
import style0 from "./DisasterPreventionManagement.vue?vue&type=style&index=0&id=0aabe9e5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aabe9e5",
  null
  
)

component.options.__file = "DisasterPreventionManagement.vue"
export default component.exports